import type { FC } from 'react'

import styled from '@emotion/styled'

import { useTheme } from '@emotion/react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import IconWrapper from '@segment/matcha/components/IconWrapper'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import useMatchMedia from '@segment/utils/useMatchMedia'

import { data } from './data'

const copy = {
  heading: `Datasheets to download`,
}

const DatasheetsToDownload: FC = () => {
  const theme = useTheme()
  const mobileResolutionMediaQuery = theme.breakpoints.down(`md`, false)
  const isSmallResolution = useMatchMedia(mobileResolutionMediaQuery, true)
  return (
    <Wrapper>
      <StyledSectionBase variant={isSmallResolution ? `2Col` : `centered`}>
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Heading tag="h2" variant="h2">
              {copy.heading}
            </CopyText.Heading>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <ColumnTrack columns={1} overrides={{ md: 3 }}>
            {data.map(({ title, description, url, icon }, index) => (
              <StyledFeatureBoxBase key={index} headerPosition="top" alignment="left">
                <FeatureBox.Header>
                  <IconWrapper background="white" elevation={1} variant="circle">
                    {icon}
                  </IconWrapper>
                </FeatureBox.Header>
                <FeatureBox.Body>
                  <FeatureBox.Title>{title}</FeatureBox.Title>
                  <FeatureBox.Text>{description}</FeatureBox.Text>
                  <StyledButtonText size="small" tag="a" href={url} iconEnd={ChevronRightIcon}>
                    Download the datasheet
                  </StyledButtonText>
                </FeatureBox.Body>
              </StyledFeatureBoxBase>
            ))}
          </ColumnTrack>
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

export default DatasheetsToDownload

const Wrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-left: 80px;
    padding-right: 80px;
  }
`
const StyledButtonText = styled(ButtonText)`
  ${({ theme }) => theme.typography.textBold.css};
  align-items: left;
  justify-content: flex-start;
  width: fit-content;
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 40px;
    max-width: 1280px;
    margin: 0 auto;
    ${({ theme }) => theme.breakpoints.up(`md`)} {
      row-gap: 56px;
    }
  }
`

const StyledFeatureBoxBase = styled(FeatureBoxBase)``
